import { Component } from 'react'

class Delayed extends Component {
    constructor(props) {
        super(props)
        this.mountTimeout = null
        this.unmountTimeout = null
        this.state = {
            isMounted: false
        }
    }

    componentDidMount() {
        if (this.props.mounted) {
            this.mount()
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.mounted && this.props.mounted) {
            this.mount()
        } else if (prevProps.mounted && !this.props.mounted) {
            this.unmount()
        }
    }

    mount() {
        clearTimeout(this.unmountTimeout)

        this.mountTimeout = setTimeout(() => {
            this.setState({ isMounted: true })
        }, this.props.mountAfter)
    }

    unmount() {
        clearTimeout(this.mountTimeout)

        this.unmountTimeout = setTimeout(() => {
            this.setState({ isMounted: false })
        }, this.props.unmountAfter)
    }

    render() {
        return this.state.isMounted && this.props.children
    }
}

Delayed.defaultProps = {
    mounted: true,
    mountAfter: 0,
    unmountAfter: 1000
}

export default Delayed


// WEBPACK FOOTER //
// ./src/containers/Delayed/index.js